import React from "react";
import type { IconProps } from "./types";

export const RegulationsRoundIcon = React.forwardRef<SVGSVGElement, IconProps>(
  function RegulationsRoundIcon({ size = 24, width, height, className = "", fill = "currentColor", ...props }, ref) {
    return (
      <svg
        ref={ref}
        width={width || size}
        height={height || size}
        viewBox="-1 0 19 19"
        xmlns="http://www.w3.org/2000/svg"
        className={className}
        {...props}
      >
        <path
          d="M16.417 9.583A7.917 7.917 0 1 1 8.5 1.666a7.917 7.917 0 0 1 7.917 7.917zm-4.483-3.848a.424.424 0 0 0-.142-.176.418.418 0 0 0-.224-.07H8.914V4.94a.396.396 0 0 0-.792 0v.55h-2.69a.395.395 0 0 0-.367.245l-1.36 3.17a.395.395 0 0 0-.032.164v.005a1.758 1.758 0 1 0 3.517 0v-.005a.386.386 0 0 0-.032-.164L6.032 6.282h2.09v5.834l-2.99 1.239a.396.396 0 0 0 .152.761h6.498a.396.396 0 0 0 .151-.761l-3.019-1.251V6.282h2.054L9.842 8.905a.39.39 0 0 0-.032.164v.005a1.758 1.758 0 1 0 3.517 0v-.005a.396.396 0 0 0-.032-.164l-1.36-3.17zM5.431 6.889l.938 2.185H4.494zm6.137 0 .937 2.185h-1.874z"
          fill={fill}
        />
      </svg>
    );
  }
);

export default RegulationsRoundIcon;
